import pathOr from 'ramda/src/pathOr'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import path from 'ramda/src/path'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'
import pick from 'ramda/src/pick'

export default (state, { moduleKey, fieldDescPath }) => {
	const fieldPath = fieldDescPath || []
	const fields = path(
		[moduleIdFromKey(moduleKey), ...fieldPath, 'assetsAdditionalField'],
		moduleDescriptions,
	)
	if (!fields) return undefined
	const formInputs = pathOr([], ['form', moduleKey, 'formInputs'], state)

	return pick(fields, formInputs)
}
